import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type {
  ListAffiliateCustomersParams,
  ListAffiliateCustomersResponse,
} from './list-affiliate-customers.types'

export const listAffiliateCustomers = async (
  params?: ListAffiliateCustomersParams,
): Promise<ListAffiliateCustomersResponse> => {
  const response = await apiClient.get<ListAffiliateCustomersResponse>(
    '/v1/affiliation/customers',
    {
      params: {
        PageNumber: params?.pageNumber ?? 1,
        PageSize: params?.pageSize ?? 10,
      },
    },
  )
  return response.data
}

export const useListAffiliateCustomers = (
  params?: ListAffiliateCustomersParams,
) => {
  return useQuery({
    queryKey: ['affiliate-customers', params],
    queryFn: () => listAffiliateCustomers(params),
  })
}
